
const initialState = {
  quantityAdults: 1,
};

const quantityAdult = ( state = initialState, action ) => {
  switch (action.type) {
    case 'ADD_QUANTITY_ADULT':
      return {
        ...state,
        quantityAdults: action.quantity,
      };
    case 'REMOVE_QUANTITY_ADULT':
      return {
        ...state,
        quantityAdults: action.quantity,
      };
    default:
      return state;
  }
};

export default quantityAdult;
